import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class NonFamilyEmployeeField extends Field<string> {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "No",
      propertyName: "nonFamilyEmployee",
      pickList: ["Yes", "No"],
      uiFieldType: "RadioInput",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const province = this._model.companyInformation.businessState.value;
    const businessType = this._model.companyInformation.businessType.value;
    if (
      registeredCountry === "Canada" &&
      province === "Quebec" &&
      businessType === "Sole Proprietorship"
    ) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
